import React  from 'react';
import { Link } from 'gatsby';
import Image from '../../atoms/Image';


const PostItem = ({
    item, id
  }) => {
    return (
<Link
className="home__post__title"
to={'/post/' + item.slug}
>
<Image
  className="home__post__image"
  filename="gatsby-post-bg.jpg"
/>
<div className="home__post__text">
  {item.proof_point ? item.proof_point : '...'}
  <div
    className="home__post__description"
    key={id}
  >
    <p>{item.headline ? item.headline : '...'}</p>
    <p>{item.image_url ? item.image_url : '...'}</p>
    <p>{item.description ? item.description : '...'}</p>
    <p>{item.caption ? item.caption : '...'}</p>
    <p>{item.link ? item.link : '...'}</p>
    <p>{item.display_link ? item.display_link : '...'}</p>
    <p>{item.cta_btn ? item.cta_btn : '...'}</p>
  </div>
</div>
</Link>
    );
  };
  
  export default PostItem;